module.exports = __webpack_public_path__ + "img/9.d7e320ff.png";